var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('iframe',{staticClass:"iframe-preview",attrs:{"id":"cts-preview-html-container","srcdoc":_vm.displayContent,"title":"html-viewer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }